@if (!turnos.length) {
    <h3 class="no-turnos">{{ 'COMPONENTS.DIALOG_INFORMACOES.alert_shift_null' | transloco }}</h3>
} @else {
  <div class="turnos-container">
    <div class="turnos-wrapper" [class.has-scroll]="hasScrollableTurnos">
      @for (turno of turnos; track turno) {
        <div class="turno">
          <div class="circle-wrapper">
            <svg class="progress-ring" width="160" height="160" viewBox="0 0 160 160">

              <circle class="progress-ring-bg"
                [class]="turno.cor"
                cx="80"
                cy="80"
                r="52"
                stroke-width="45"/>

              <circle class="progress-ring-circle"
                [class]="turno.cor"
                cx="80"
                cy="80"
                r="52"
                stroke-width="45"
                [style.stroke-dasharray]="2 * Math.PI * 52"
                [style.stroke-dashoffset]="2 * Math.PI * 52 * (1 - turno.porcetagemProdutividade/turno.produtividadeMaxima)"/>
            </svg>

            <div class="circle-content">
              <span>{{ formatarValor(turno.porcetagemProdutividade) }} HA</span>
            </div>
          </div>

          <p>{{ turno.nome }}</p>
        </div>
      }
    </div>
  </div>
}